<template>
  <div class="body">
    <div class="header">大工</div>
    <div class="content">
      <block v-for="(item, index) in dgList" :key="item._id">
        <div class="userItem">
          <div 
            @click="choseThisService('dg', index)" 
            class="item" 
            :class="{ checked: dg._id === item._id }">
            {{ item.name }}
          </div>
        </div>
      </block>
    </div>

    <div class="header">中工</div>
    <div class="content">
      <block v-for="(item, index) in zgList" :key="item._id">
        <div class="userItem">
          <div 
            @click="choseThisService('zg', index)" 
            class="item" 
            :class="{ checked: zg._id === item._id }">
            {{ item.name }}
          </div>
        </div>
      </block>
    </div>

    <div class="header">小工</div>
    <div class="content">
      <block v-for="(item, index) in xgList" :key="item._id">
        <div class="userItem">
          <div 
            @click="choseThisService('xg', index)" 
            class="item" 
            :class="{ checked: xg._id === item._id }">
            {{ item.name }}
          </div>
        </div>
      </block>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, getCurrentInstance, onMounted,defineEmits,defineProps} from 'vue'
import { stateShop } from '@/store'

// 定义 props
const props = defineProps({
  orderType: {
    type: Number,
    default: 2
  },
  productItem: {
    type: Object,
    default: () => ({})
  }
})

// 定义 emits
const emit = defineEmits(['confirm'])

const { proxy } = getCurrentInstance()
const app = proxy.$cloudbase

// 响应式数据
const dgList = ref([])
const zgList = ref([])
const xgList = ref([])

const dg = reactive({})
const zg = reactive({})
const xg = reactive({})

// 加载店铺用户
const loadShopUser = async () => {
  try {
    const db = app.database()
    const shopId = stateShop._id
    
    const res = await db.collection("my_user").where({
      deleted: 0,
      active: true,
      shopId
    }).field({
      _id: true,
      jobType: true,
      role: true,
      roleId: true,
      name: true
    }).get()

    const userList = res.data

    xgList.value = userList.filter(item => item.jobType?.includes('小工'))
    zgList.value = userList.filter(item => item.jobType?.includes('中工'))
    dgList.value = userList.filter(item => item.jobType?.includes('大工'))

    // 检查是否有预选的提成信息
    const { ticheng } = props.productItem

    if (ticheng && Array.isArray(ticheng)) {
      for (const item of ticheng) {
        if (item.type === "dg") {
          Object.assign(dg, item)
        } else if (item.type === "zg") {
          Object.assign(zg, item)
        } else if (item.type === "xg") {
          Object.assign(xg, item)
        }
      }
    }
  } catch (error) {
    console.error('加载店铺用户失败:', error)
  }
}

// 选择服务人员
const choseThisService = async (type, index) => {
  try {
    let seller = {}
    
    if (type === "dg") {
      seller = dgList.value[index]
    } else if (type === "zg") {
      seller = zgList.value[index]
    } else if (type === "xg") {
      seller = xgList.value[index]
    }

    const shopId = stateShop._id
    const db = app.database()
    
    const res = await db.collection("my_commission").where({
      status: 2,
      orderType: props.orderType,
      roleId: seller.roleId,
      shopId
    }).get()

    const commission = res.data.length > 0 ? res.data[0] : null

    emit('confirm', {
      seller,
      commission
    })
  } catch (error) {
    console.error('选择服务人员失败:', error)
  }
}

// 生命周期
onMounted(() => {
  loadShopUser()
})
</script>

<style scoped>
.body {
  background-color: white;
  padding: 2vw;
  box-sizing: border-box;
}

.header {
  font-weight: 700;
  margin: 4vw 0 2vw;
}

.content {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 6vw;
}

.userItem {
  position: relative;
  display: flex;
  align-items: center;
}

.content .item {
  padding: 1vw 0;
  width: 19vw;
  text-align: center;
  box-sizing: border-box;
  height: 9vw;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3vw 2vw;
  color: rgb(65, 65, 65);
  background-color: rgb(243, 243, 243);
  border: 1px solid rgb(243, 243, 243);
  border-radius: 4px;
}

.content .checked {
  border: 1px solid rgb(19, 19, 19);
  font-weight: 700;
}

.box {
  width: 90vw;
  padding: 32px;
  display: flex;
  justify-content: space-between;
  background-color: #fff;
}

.footerBar {
  display: flex;
  justify-content: flex-end;
}
</style>